var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSpinnerVisible)?_c('div',{staticClass:"spinner-overlay"},[_c('b-spinner',{staticStyle:{"width":"2rem","height":"2rem"},attrs:{"type":"grow","variant":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }